import * as getCompetitions from './reducers/get';
import * as query from './reducers/query';
import * as create from './reducers/create';
import * as save from './reducers/save';
import * as move from './reducers/move';
import { subscribe, unsubscribe } from './reducers/subscription';
import { update, bulk as bulkUpdate } from './reducers/update';
import { update as updateCollection } from './reducers/update-collection';
import * as moveList from './reducers/move-list';

import { simple } from 'src/utils/reducers';

// eslint-disable-next-line import/no-default-export
export default simple({
    COMPETITIONS_REQUEST: getCompetitions.request,
    COMPETITIONS_ERROR: getCompetitions.error,
    COMPETITIONS_FINISH: getCompetitions.finish,

    COMPETITIONS_QUERY_REQUEST: query.request,
    COMPETITIONS_QUERY_ERROR: query.error,
    COMPETITIONS_QUERY_FINISH: query.finish,

    COMPETITIONS_CREATE_REQUEST: create.request,
    COMPETITIONS_CREATE_ERROR: create.error,
    COMPETITIONS_CREATE_FINISH: create.finish,

    COMPETITIONS_SAVE_REQUEST: save.request,
    COMPETITIONS_SAVE_ERROR: save.error,
    COMPETITIONS_SAVE_FINISH: save.finish,

    COMPETITIONS_LIST_MOVE_REQUEST: moveList.request,
    COMPETITIONS_LIST_MOVE_ERROR: moveList.error,
    COMPETITIONS_LIST_MOVE_FINISH: moveList.finish,

    COMPETITIONS_MOVE_REQUEST: move.request,
    COMPETITIONS_MOVE_ERROR: move.error,
    COMPETITIONS_MOVE_FINISH: move.finish,

    COMPETITIONS_SUBSCRIBE: subscribe,
    COMPETITIONS_UNSUBSCRIBE: unsubscribe,

    COMPETITIONS_UPDATE_COLLECTION: updateCollection,

    COMPETITIONS_DATA: bulkUpdate,
    COMPETITION_DATA: update,
});
